<template>
	<Head title="Criar aula teste"></Head>
	<div class="col-xl-12">
		<div class="card card-xl-stretch mb-xl-8">
			<div class="card-header border-0">
				<h3 class="card-title fw-bolder text-dark">
					<span class="fa-solid fa-desktop"></span>
					<span class="ms-3">Criar aula online para teste</span>
				</h3>
			</div>
			<div class="card-body">
				<div class="row">
					<div class="col-12 col-md-4">
						<label for="phone-number" class="form-label">
							Telefone do aluno
						</label>
						<input
							v-maska="phone_obj"
							data-maska="['+55 (##) #####-####']"
							v-model="phone"
							type="text"
							class="form-control"
							id="phone-number"
							placeholder="(##) #####-####" />
					</div>
					<div class="col-12 col-md-4 mt-5 mt-md-0 align-self-end">
						<div class="d-grid gap-2">
							<button
								@click="generateTestRoomUrl"
								class="btn btn-primary"
								type="button"
								:disabled="loading">
								<div v-if="loading">
									<i class="fa fa-spinner fa-spin me-1"></i>
									Carregando
								</div>
								<span v-else>Gerar sala de teste</span>
							</button>
						</div>
					</div>
					<div
						class="col-12 col-md-4col-12 col-md-4 mt-5 mt-md-0 align-self-end">
						<div class="d-grid gap-2">
							<button
								@click="sendUrlOnWhatsapp"
								class="btn btn-success"
								type="button"
								:disabled="phone_wpp.length < 13">
								Enviar link por whatsapp
								<i class="fa-brands fa-whatsapp"></i>
							</button>
						</div>
					</div>
				</div>
				<div class="row mt-10">
					<div v-if="response_success" class="col-12 col-md-6">
						<div
							class="row alert alert-success d-flex justify-content-between align-items-center text-break"
							role="alert">
							<div class="col-12 col-md-10">
								<span>
									Link gerado com sucesso:
									<a :href="link" target="_blank">
										{{ link }}
									</a>
								</span>
							</div>

							<div
								class="col-12 col-md-2 mt-8 mb-5 mt-md-0 mb-md-0 d-flex justify-content-center justify-content-md-end"
								style="cursor: pointer">
								<span
									@click="copyToClipboard"
									data-bs-toggle="tooltip"
									data-bs-title="Copiar"
									class="fa-solid fa-copy fa-xl">
								</span>
							</div>
						</div>
					</div>
					<div v-if="response_error" class="col-12 col-md-6">
						<div class="alert alert-danger text-break" role="alert">
							<p>Não foi possível gerar o link.</p>
							<p>Erro: {{ error_message }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { Head } from '@inertiajs/vue3';
	import { computed, reactive, ref } from 'vue';
	import { vMaska, MaskaDetail } from 'maska';
	import axios from 'axios';

	const props = defineProps({
		generate_test_room_url_route: { type: String, required: true },
	});

	let response_success = false;
	let response_error = false;
	let error_message = '';
	let phone = '';
	let loading = ref(false);
	let link = '';
	const phone_obj = reactive({}) as MaskaDetail;
	const phone_wpp = computed(() => `55${phone_obj.unmasked}`);

	function copyToClipboard() {
		window.navigator.clipboard.writeText(link);
	}

	async function generateTestRoomUrl() {
		loading.value = true;
		response_success = false;
		response_error = false;

		try {
			const response = await axios.get(
				props.generate_test_room_url_route
			);
			link = response.data.url;
			response_success = true;
		} catch (error: any) {
			response_error = true;
			error_message = error.response.data.message;
		} finally {
			loading.value = false;
		}
	}

	async function sendUrlOnWhatsapp() {
		if (!link) {
			await generateTestRoomUrl();
		}

		let url = `https://wa.me/${phone_wpp.value}?text=${encodeURIComponent(
			'Link para aula de teste: ' + link
		)}`;
		window.open(url, '_blank');
	}
</script>
